module.exports = __webpack_public_path__ + "media/02_【アプリ版】機械登録.2d161022.mp4";